const collectionSlider = document.querySelector('.our-collection-slider');

if (collectionSlider) {
  const initCollectionSwiper = () => {
    new Swiper(collectionSlider, {
      preloadImages: false,
      updateOnImagesReady: false,

      watchSlidesProgress: false,
      watchOverflow: true,

      observer: false,
      observeParents: false,

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },

        580: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },

        767: {
          slidesPerView: 3,
          spaceBetween: 20,
        },

        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initCollectionSwiper();
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '200px'
    });

    observer.observe(collectionSlider);
  } else {
    initCollectionSwiper();
  }
}